/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react'
import { saveAs } from 'file-saver';

/** Common Components */
import CardSection from '../../../../components/ui/card/CardSection';
import { ServiceLocationContext } from '../../../../utils/context/ServiceLocationContext';
import SwalAlert from '../../../../services/swalService/SwalService';
import ToastService from '../../../../services/toastService/ToastService';
import formatDate from '../../../../components/finalMolGrid/libs/formatDate';
import MolGrid, { Column } from '@moltech/molui/molgrid';

/**Wrapped Component */
import Financial from '../../Financial';

/** utilities */
import { customRowsPerPageDropdown, getDropdownValue } from '../../../../components/finalForms/libs/data/dropdownUtilities';

/** CSS Files */
import "../../Financial.scss";

/** API call */
import { useGetMolGridDataMutation } from "../../../../app/services/commonAPI";
import { useExportWorkOrdersOnHoldMutation, useWorkOrderUpdateOnHoldMutation } from '../../../../app/services/financialsAPI';

const WorkOrdersOnHold = () => {

  const { selectedLocation } = useContext(ServiceLocationContext);
  const locationkey = getDropdownValue(selectedLocation);
  const { confirm } = SwalAlert();

  const gridRef = useRef();
  const currentDate = formatDate(new Date(), "MM-DD-YYYY");
  const [isDisable, setIsDisable] = useState(true);

  const [exportWorkOrdersOnHold, {
    isLoading: isAllExporting,
    isSuccess: isAllExported,
    data: exportAllData
  }] = useExportWorkOrdersOnHoldMutation();

  const [workOrderUpdateOnHold, {
    isSuccess: isworkOrderUpdateSuccess,
    data: workOrderUpdateData,
  },] = useWorkOrderUpdateOnHoldMutation();

  useEffect(() => {
    if (isworkOrderUpdateSuccess) {
      ToastService.success("Work Order On Hold Update Successfully!");
    }
  }, [isworkOrderUpdateSuccess, workOrderUpdateData]);

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.reload();
    }
  }, [isworkOrderUpdateSuccess, locationkey]);

  // Export All Details response handling
  useEffect(() => {
    if (!isAllExporting && isAllExported && exportAllData) {
      const blob = new Blob([exportAllData]);
      saveAs(blob, `Work Orders On Hold ${currentDate}.xlsx`);
    }
  }, [isAllExporting, isAllExported, exportAllData]);


  const beforeMolGridLoad = (reqPrm) => {
    const req = {
      pagination: {
        pageNumber: (reqPrm.first / reqPrm.rows) + 1,
        pageSize: reqPrm.rows
      },
      sortField: reqPrm.sortField,
      sortOrder: reqPrm.sortOrder,
      plClientKey: null,
      plServiceLocationKey: locationkey,
      plSalesRepKey: null,
      plRepairKey: null,
      groupBy: reqPrm.groupBy ? reqPrm.groupBy : '',
    };
    return req;
  }

  const afterMolGridLoad = (data) => {
    setIsDisable(false);
    return {
      data: data.dataSource,
      count: data.totalRecord
    };
  }

  const UpdateWorkOrderOnHold = async (rowData) => {
    if (!rowData) return;

    const isOnHold = !rowData.bByPassOnHold;
    let pbBypassOnHold = isOnHold;
    let pbAllRepairsForClient = false;

    if (isOnHold) {
      const ok = await confirm(
        "Authorize Work Order?",
        "Are you sure you want to authorize this Work Order?",
        "Yes",
        "No"
      );
      if (!ok) return;
    }

    const choice = await confirm(
      isOnHold ? "Authorize Work Order" : "Put Work Order On Hold",
      isOnHold
        ? "Click 'Yes' to authorize all work orders for this client (current and future), or 'No' to only authorize this particular work order."
        : "Click 'Yes' to put all work orders for this client on hold again, or 'No' to only hold this particular work order.",
      "Yes",
      "No",
      "Cancel"
    );

    if (choice === null) return;
    pbAllRepairsForClient = choice;

    workOrderUpdateOnHold({
      plRepairKey: rowData.lRepairKey,
      pbAllRepairsForClient,
      pbBypassOnHold,
    });
  };

  const rowClass = (rowData) => {
    return {
      'green-color-row': rowData.bByPassOnHold === true,
      'black-color-row': rowData.bByPassOnHold === false,
    };
  };

  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: row?.bByPassOnHold ? "Put On Hold Again" : "Authorize",
        //  icon: 'pi pi-plus',
        command: () => UpdateWorkOrderOnHold(row)
      }
    ];
  }

  const handleDownloadClick = () => {
    const request = {
      plClientKey: null,
      plServiceLocationKey: locationkey,
      plSalesRepKey: null,
      plRepairKey: null
    };
    exportWorkOrdersOnHold(request);
  }

  return (

    <div className="supplier-po-table head-center clients-on-hold-list small-card-btn-sec">
      <CardSection
        cardTitle={`Work Order On Hold`}
        isButtonVisible={true}
        titleButtonClick={handleDownloadClick}
        rightButton={true}
        buttonClassName={'blue-btn mb-1'}
        titleText={'Export'}
        isIcon={true}
        iconClass="file-icons:microsoft-excel"
        isButtonDisable={isDisable}
        isButtonLoading={isAllExporting}
      >
        <div className="scrollable-grid">
          <MolGrid ref={gridRef} url="/Financials/GetAllWorkOrdersOnHold" client={useGetMolGridDataMutation}
            beforeLoad={beforeMolGridLoad}
            afterLoad={afterMolGridLoad}
            grouping
            expandableRowGroups={true}

            scrollable
            scrollHeight="flex"
            filterDisplay="row"

            sortMode="single"
            showGridlines
            resizableColumns

            rowClassName={rowClass}
            paginator
            rowsPerPageOptions={[10, 25, 50, 100]}
            rows={99999}
            paginatorTemplate={{
              layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              RowsPerPageDropdown: (options) => {
                return customRowsPerPageDropdown(options, options?.value)
              }
            }}
            ctxMenuItems={getCtxMenuItems}
          >
            <Column field="sCompanyName1" header="Company" grouping sortable />
            <Column field="sClientName1" header="Client" grouping sortable />
            <Column field="sDepartmentName" header="Department" grouping sortable />
            <Column field="sWorkOrderNumber" header="Work Order" bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="dtDateIn" header="Date In" colType="datetime" format="mm/dd/yyyy" bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="repName" header="Sales Rep" grouping sortable />
          </MolGrid>
        </div>
      </CardSection>
    </div>
  )
};
export default Financial(WorkOrdersOnHold)
